import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyAXeNet35Tr4u4C2ejpWHJ7TZ44WMyOF_k",
    authDomain: "aotchron.firebaseapp.com",
    projectId: "aotchron",
    storageBucket: "aotchron.appspot.com",
    messagingSenderId: "612490328151",
    appId: "1:612490328151:web:f4fef10dbd328d72678b12"
  };
  
initializeApp(firebaseConfig);

createApp(App).use(router).mount('#app')
